import * as React from 'react';

/**
 * Ícone sólido de casa (telhado preenchido com a porta vazada), do arquivo
 * `icon-home.svg` entregue pelo design.
 *
 * Segue o mesmo contrato dos demais ícones do header: sem width/height fixos
 * (o tamanho vem da classe) e preenchimento em `currentColor`, para herdar a
 * cor do link no tema claro, no escuro e no modo de alto contraste — o
 * original trazia `#F3F2F7` fixo. O desenho tem 23×19; o viewBox o
 * centraliza numa moldura de 24×24, como no layout.
 */
export const HouseIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="-0.75 -2.625 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    focusable="false"
    {...props}
  >
    <path d="M21.75 17.2502H20.25V10.5002L20.4694 10.7196C20.6104 10.8603 20.8015 10.9393 21.0007 10.9391C21.1999 10.939 21.3908 10.8597 21.5316 10.7187C21.6723 10.5777 21.7513 10.3866 21.7511 10.1874C21.7509 9.98819 21.6716 9.79722 21.5306 9.65649L12.3103 0.438992C12.029 0.1579 11.6477 0 11.25 0C10.8523 0 10.471 0.1579 10.1897 0.438992L0.969375 9.65649C0.828769 9.79722 0.749827 9.98805 0.749914 10.187C0.750002 10.3859 0.829113 10.5767 0.969844 10.7173C1.11057 10.8579 1.3014 10.9368 1.50033 10.9367C1.69927 10.9366 1.89002 10.8575 2.03062 10.7168L2.25 10.5002V17.2502H0.75C0.551088 17.2502 0.360322 17.3293 0.21967 17.4699C0.0790176 17.6106 0 17.8013 0 18.0002C0 18.1992 0.0790176 18.3899 0.21967 18.5306C0.360322 18.6712 0.551088 18.7502 0.75 18.7502H21.75C21.9489 18.7502 22.1397 18.6712 22.2803 18.5306C22.421 18.3899 22.5 18.1992 22.5 18.0002C22.5 17.8013 22.421 17.6106 22.2803 17.4699C22.1397 17.3293 21.9489 17.2502 21.75 17.2502ZM13.5 17.2502H9V12.7502C9 12.6508 9.03951 12.5554 9.10983 12.4851C9.18016 12.4148 9.27554 12.3752 9.375 12.3752H13.125C13.2245 12.3752 13.3198 12.4148 13.3902 12.4851C13.4605 12.5554 13.5 12.6508 13.5 12.7502V17.2502Z" />
  </svg>
);

export default HouseIcon;
